import { useParams } from 'react-router-dom';
import { useUnmount } from 'ahooks';
import { Col, Row } from 'antd';

import {
  Container,
  FetchImage,
  Loader,
  Status,
  TitledContainer,
} from 'components';

import { getIsNew } from 'utils';

import { ProductExclusionTable, RetailerForm, Title } from './components';
import { useRetailerDetails } from './hooks';
import { resetRetailerStoreAction, retailerStore } from './store';

export const Retailer = () => {
  const imgId = retailerStore((state) => state.imgId);
  const status = retailerStore((state) => state.status);

  const { loading } = useRetailerDetails();
  const { retailerId } = useParams();

  const isNew = getIsNew(retailerId);

  useUnmount(() => {
    resetRetailerStoreAction();
  });

  return (
    <Loader
      isFullHeight
      isLoading={loading}
    >
      <TitledContainer
        backLink
        scrollable
        title={<Title />}
        titleExtraNode={<Status status={status} />}
      >
        <Container className='mb-7'>
          <Row gutter={24}>
            <Col xs={8} xxl={6}>
              <FetchImage
                alt='Offer'
                imgId={imgId}
                preview={false}
              />
            </Col>

            <Col xl={12}>
              <RetailerForm />
            </Col>
          </Row>
        </Container>

        {!isNew && (
          <Container>
            <ProductExclusionTable />
          </Container>
        )}
      </TitledContainer>
    </Loader>
  );
};
